import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../http-client/http-client.service';
import { SchoolYear } from '../../models/school-years/school-year';
import { Service } from '../service';

@Injectable()
export class SchoolYearService extends Service {

    public schoolYear: SchoolYear[];
    public schoolYearObject: any;

    constructor(private http: HttpClientService) {
        super();
        this.schoolYear = [];
        this.schoolYearObject = {};
    }

    public getAll(): Observable<SchoolYear[]> {           
        if (!!this.schoolYear && this.schoolYear.length > 0) {
            return Observable.create((observer: Subscriber<SchoolYear[]>) => {
                observer.next(this.schoolYear);
                observer.complete();
            });
        }
        const url = 'schoolyears/all';
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.schoolYear = r.Result;
                this.schoolYearObject = this.schoolYear.reduce((result, st) => {
                    result[String(st.Id)] = result[String(st.Id)] || {};
                    result[String(st.Id)] = st;
                    return result;
                }, {});
            } else {
                console.error('relationshipsService > getAll > response', r);
            }
            return this.schoolYear;
        }).catch(this.handleError);
    }

    public getById(id): Observable<SchoolYear> {
        const url = 'schoolyears/byid/' + id;
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                this.schoolYear = r.Result;
            } else {
                console.error('relationshipsService > getAll > response', r);
            }
            return r.Result;
        }).catch(this.handleError);
    }

    public add(data: any) {
        const url = 'schoolyears/add';
        return this.http.post(url, data).map(response => response.json())
            .catch(this.handleError);
    }

    setCurrent(id: any) {
        const url = 'schoolyears/setcurrent/' + id;
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                console.log('OK>>>>>>>>>>');
            } else {
                console.error('relationshipsService > getAll > response', r);
            }
            return r.Result;
        }).catch(this.handleError);
    }

    setCurrentInscription(id: any) {
        const url = 'schoolyears/setcurrentinscription/' + id;
        return this.http.get(url).map(response => {
            const r = response.json();
            if (r.ResultCode === 1) {
                console.log('OK>>>>>>>>>>');
            } else {
                console.error('relationshipsService > getAll > response', r);
            }
            return r.Result;
        }).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/schoool-year/school-year.service.ts